<template>
    <div class="pt-8 pb-48 px-2">
        <div v-if="loaded" class="max-w-screen-xl mx-auto flex flex-col">
            <router-link
                :to="'/lediga-lagenheter/'"
                class="block flex flex-row items-center cursor-pointer w-2/3 sm:w-1/2 lg:w-3/12 mb-4 border-b-2 border-b-mimer-turquoise py-2">
                <svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="20" height="20">
                    <path
                        d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z" />
                </svg>
                <p class="text-sm md:text-base font-medium pl-2">Tillbaka till sökning</p>
            </router-link>

            <apartment-detail-header :currentApartment="currentApartment" />

            <apartment-description :currentApartment="currentApartment" />

            <div
                v-if="!showApplicantProfile && !tooLargeHouseholdToBeAbleToApply"
                class="p-10 mb-10 bg-mimer-gray flex flex-col items-center text-sm md:text-base">
                <b class="my-2">Är du intresserad av objektet?</b>
                <div class="my-4 flex flex-row justify-center items-center" v-if="loggedInStatus && errorMessage">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.com/svgjs"
                        version="1.1"
                        width="24"
                        height="24"
                        x="0"
                        y="0"
                        viewBox="0 0 24 24"
                        style="enable-background: new 0 0 512 512"
                        xml:space="preserve">
                        <g>
                            <path
                                xmlns="http://www.w3.org/2000/svg"
                                d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
                                fill="#000000"
                                data-original="#000000" />
                            <path
                                xmlns="http://www.w3.org/2000/svg"
                                d="M12,5a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V6A1,1,0,0,0,12,5Z"
                                fill="#000000"
                                data-original="#000000" />
                            <rect
                                xmlns="http://www.w3.org/2000/svg"
                                x="11"
                                y="17"
                                width="2"
                                height="2"
                                rx="1"
                                fill="#000000"
                                data-original="#000000" />
                        </g>
                    </svg>
                    <div v-if="loggedInStatus">
                        <p class="italic pl-2">{{ errorMessage }}</p>
                    </div>
                    <div v-else>
                        <p class="italic pl-2">Du behöver logga in för att anmäla intresse på detta objekt.</p>
                    </div>
                </div>

                <div v-if="loggedInStatus">
                    <div v-if="noteofinterest">
                        <mimer-button
                            v-if="noteofinterest.canBeDeleted"
                            @click="removeIntersest"
                            text="Ta bort intresseanmälan" />
                        <p v-else class="_pt-4 _pb-2 _m-0 _italic">Du har anmält intresse för objektet.</p>
                    </div>
                    <div v-else>
                        <div v-if="!notedInterest && !tooLargeHouseholdToBeAbleToApply">
                            <div v-if="isLoading" class="mimer-button relative" style="width: 125px; height: 60px">
                                <img
                                    src="../assets/3-dots-scale-white-36.svg"
                                    class="absolute w-full top-0 left-0 h-full" />
                            </div>
                            <mimer-button v-else @click="apply" text="Anmäl intresse" />
                        </div>
                        <!--                        <div v-else-if="!notedInterest && toLargeHouseholdToBeAbleToApply">
                          <VerifyApplicationError />
                        </div>-->
                        <div class="p-4 px-8 bg-gray-200" v-else>
                            <i class="material-icons text-green">done</i>
                            Intresse anmält
                        </div>
                    </div>
                </div>
                <div v-else>
                    <mimer-button @click="redirectToLogin" text="Logga in för att anmäla intresse" />
                </div>

                <div class="my-4" v-if="currentApartment.publishedTo">
                    Sista anmälningsdatum är den
                    {{ currentApartment.publishedTo.split('T')[0] }}
                </div>
            </div>

            <div v-else-if="!showApplicantProfile && !notedInterest && tooLargeHouseholdToBeAbleToApply">
                <VerifyApplicationError />
            </div>

            <SupplyApplicationProfile
                v-show="showApplicantProfile"
                v-on:onProfileSaved="noteInterest"
                v-on:onProfileFetched="applicationProfileFetchedHandler" />

            <MimerMap :address="currentApartment.postalAddress"></MimerMap>
        </div>

        <div v-if="!loaded" class="max-w-screen-xl mx-auto flex flex-col">
            <router-link
                :to="'/lediga-lagenheter/'"
                class="block flex flex-row items-center cursor-pointer w-2/3 md:w-3/12 mb-4 border-b-2 border-b-mimer-turquoise py-2">
                <svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="20" height="20">
                    <path
                        d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z" />
                </svg>
                <p class="text-xl font-medium pl-2">Tillbaka till sökning</p>
            </router-link>
            <div class="w-full md:w-2/6 h-16 bg-gray-200 animate-pulse mb-4"></div>
            <div class="w-full md:w-full h-96 bg-gray-200 animate-pulse mb-4"></div>
            <div class="w-full md:w-3/6 h-16 bg-gray-200 animate-pulse mb-4"></div>
            <div class="w-full md:w-3/6 h-96 bg-gray-200 animate-pulse mb-4"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { loggedInStatus, invalidateSession } from '../utils/helpers';
import { MimerButton } from 'mimer-components';
import MimerMap from '../components/Common/MimerMap.vue';
import VerifyApplicationError from '@/views/VerifyApplicationError.vue';
import SupplyApplicationProfile from '@/components/Common/SupplyApplicationProfile.vue';
import ApartmentDetailHeader from '@/components/Apartment/ApartmentDetailHeader.vue';
import ApartmentDescription from '@/components/Apartment/ApartmentDescription.vue';

export default {
    name: 'AppartmentDetail',
    components: {
        SupplyApplicationProfile,
        VerifyApplicationError,
        MimerButton,
        MimerMap,
        ApartmentDetailHeader,
        ApartmentDescription,
    },
    data() {
        return {
            currentApartment: null,
            showBlueprint: true,
            loaded: false,

            isLoading: false,

            loggedInStatus: loggedInStatus(),
            noteofinterest: null,
            notedInterest: false,
            showApplicantProfile: false,
            shouldSupplyApplicantProfile: false,
            errorMessage: null,
            tooLargeHouseholdToBeAbleToApply: false,
        };
    },
    methods: {
        toggleBlueprint() {
            this.showBlueprint = !this.showBlueprint;
        },

        redirectToLogin() {
            location.href = '/mina-sidor/?redirection=/sok-ledigt' + this.$route.path;
        },

        applicationProfileFetchedHandler(shouldSupplyHouseHoldCount) {
            this.shouldSupplyApplicantProfile = !!shouldSupplyHouseHoldCount;
        },

        async apply() {
            if (this.shouldSupplyApplicantProfile) {
                this.showApplicantProfile = true;
            } else {
                await this.noteInterest();
            }
        },

        async noteInterest() {
            this.errorMessage = '';
            this.isLoading = true;
            this.showApplicantProfile = false;
            this.tooLargeHouseholdToBeAbleToApply = false;
            //Do the request to note interest
            let response = await axios.post(
                process.env.VUE_APP_API_URL + '/api/noteofinterests/',
                {
                    rentalObjectCode: this.$route.params.id,
                },
                {
                    headers: { Authorization: `Bearer ${loggedInStatus()}` },
                    validateStatus: function () {
                        return true;
                    },
                }
            );
            try {
                if (response.status === 204) {
                    await this.fetchObject();
                    this.notedInterest = true;
                }
                if (response.status === 500) {
                    if (response.data.detail === 'Applicant profile did not pass verification') {
                        this.tooLargeHouseholdToBeAbleToApply = true;
                    } else {
                        this.errorMessage = response.data.detail.replace('XPAND ERROR: ', '');
                    }
                }
                //Hide the loader
                this.isLoading = false;
            } catch (err) {
                //Hide the loader
                this.isLoading = false;
                console.error('Failed to update the account:', err);
                return err;
            }
        },

        async removeIntersest() {
            let response = await axios.delete(
                process.env.VUE_APP_API_URL + '/api/noteofinterests/' + this.noteofinterest.code,
                {
                    headers: { Authorization: `Bearer ${loggedInStatus()}` },
                }
            );
            try {
                if (response.status === 204) {
                    await this.fetchObject();
                    this.noteofinterest = null;
                }
            } catch (err) {
                console.error('Failed to update the account:', err);
                return err;
            }
        },

        async fetchObject() {
            let appartmentResp = await axios.get(
                process.env.VUE_APP_API_URL + '/api/publishedRentalObjects/apartments/' + this.$route.params.id,
                {
                    headers: { Authorization: `Bearer ${loggedInStatus()}` },
                }
            );
            this.currentApartment = appartmentResp.data;
        },
    },
    async mounted() {
        //Fetch the rental object
        await this.fetchObject();

        //If the user is logged in fetch all notes of interest to check the status against this object
        if (loggedInStatus()) {
            axios
                .get(process.env.VUE_APP_API_URL + '/api/applicants/me/noteofinterests/', {
                    headers: {
                        Authorization: `Bearer ${loggedInStatus()}`,
                    },
                })
                .then((res) => {
                    this.noteofinterest = res.data.find(
                        (n) => (n.rentalObjectCode === this.$route.params.id) & (n.status === 'current')
                    );
                })
                .catch(() => {
                    invalidateSession();
                    this.loggedInStatus = false;
                });
        }

        this.loaded = true;
    },
};
</script>
